<template>
  <div class="d-flex align-center">
    <span class="mr-2">{{ params.data.name }}</span>
    <v-tooltip top>
      <template v-slot:activator="{ on, attrs }">
        <v-chip
          v-if="params.data.is_default"
          label
          depressed
          small
          outlined
          class="rounded-lg"
          v-bind="attrs"
          v-on="on"
          color="orange"
        >
          Default
        </v-chip>
      </template>
      <span class="text-capitalize">Default Project</span>
    </v-tooltip>
  </div>
</template>

<script>
export default {
  name: "DefaultProjectChip",
};
</script>

<style></style>
